import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import ReportLinkModel from "../../models/report-link";
import DataTableView from "./table";

import templates from "../../utils/templates";

const channel = Radio.channel("global");

class View extends Marionette.LayoutView {
  className() {
    return "drilldown";
  }

  ui() {
    return {
      tab: ".nav a",
    };
  }

  events() {
    return {
      "click @ui.tab": "_handleTabClick",
    };
  }

  initialize(options) {
    this.template = templates.find("layout", `drilldown_${options.type}_view`);

    // listen for tab selections
    this.listenTo(channel, "drilldown:report", this._onReport);
  }

  onBeforeRender() {
    // process tabs
    this._prepareTabs();
  }

  onShow() {
    // trigger click event on default tab
    const activeTab = this.$("li.active > a");
    if (activeTab) {
      activeTab.trigger("click");
    } else {
      console.warn(
        "A default tab could not be found. Unable to display drilldown content."
      );
    }
  }

  _prepareTabs() {
    const menu = this.model.getMenu();
    if (menu && menu.length) {
      // look for active tab
      const activeTab = menu.findWhere({ active: true });

      // mark the first tab active, when none is found
      if (!activeTab) {
        menu.at(0).set("active", true);
      }

      // create regions
      this._createRegions(menu);
    }
  }

  _createRegions(menu) {
    const list = menu.pluck("name");

    _.each(list, (item) => {
      this.addRegion(`tab-${item}`, `#tab-${item}`);
    });
  }

  _handleTabClick(e) {
    const target = $(e.currentTarget);
    const data = target.data();

    // set active region
    this.activeRegion = target.attr("aria-controls");

    // navigate to clicked route
    channel.request("router:navigate", data.route);
  }

  /**
   * Handles tab activation.
   *
   * @param {RouteModel} route
   */
  _onReport(route) {
    // extract link data
    const nav = route.getNav();
    const endpoint = nav.url;
    const data = nav.data;

    // build url model
    const urlModel = new ReportLinkModel({
      endpoint,
      data,
    });

    // export endpoint data
    this.activeEndpoint = {
      endpoint: urlModel.getFinalEndpoint(),
      params: urlModel.getData(),
      url: urlModel.getUrl(),
    };

    // config tab
    this.tabConfig = {
      activeRegion: this.activeRegion,
      model: route,
      endpoint: this.activeEndpoint.endpoint,
      params: this.activeEndpoint.params,
    };

    // display report in active region
    this.getRegion &&
      this.getRegion(this.activeRegion).show(new DataTableView(this.tabConfig));
  }
}

export { View as default };
